var app = angular.module("leonardo");

var TemplateInlineEdit = function($scope, $controller, ngDialog, $rootScope, AttachmentService, FilterService, $state,
                                  TemplateService, $q, AccountUserService, PermissionService, FormErrorsService,
                                  AuthDataService, WhiteLabelService, ClientInstanceService) {

  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.whiteLabelService = WhiteLabelService;
  $scope.clientInstanceService = ClientInstanceService;
  $scope.accountUsers = [];

  $controller('TemplateBaseForm', {
    $scope: $scope,
    ngDialog: ngDialog,
    TemplateService: TemplateService,
    AttachmentService: AttachmentService,
    FilterService: FilterService,
    $state: $state,
    $q: $q,
    AccountUserService: AccountUserService
  });

  $scope.lagTypes = TemplateService.BUILT_TYPES;


  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid || $scope.errorRole) {
      FormErrorsService.goToError();
      return;
    }
    var depth = $scope.template.depth;
    $scope.template.patch($scope.getData()).then(function(template) {
      TemplateService.get(template.id).then(function(data) {
        data.depth = depth;
        $rootScope.$broadcast('template:updated', data);
      });
    });
  };

  $scope.onFullEditClick = function() {
    var template = $scope.getData(true);

    TemplateService.get($scope.template.id).then(function(data){
      angular.forEach(template, function(value, key) {
        data[key] = template[key];
      });
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/form.html',
        className: 'ngdialog-theme-default ngdialog-template-edit',
        controller: 'TemplateFormDialog',
        data: {
          template: data
        }
      }).then(function(result){
        $rootScope.$broadcast('template:updated', result);
      }, function () {
        return;
      });
    });
  };

  $scope.initParams();

};

app.controller('TemplateInlineEdit', ['$scope', '$controller', 'ngDialog', '$rootScope', 'AttachmentService',
  'FilterService', '$state', 'TemplateService', '$q', 'AccountUserService', 'PermissionService', 'FormErrorsService',
  'AuthDataService', 'WhiteLabelService', 'ClientInstanceService', TemplateInlineEdit]);
